import {
  faFreeCodeCamp,
  faGithub,
  faWhatsapp,
  faTelegram,
  faVk,
} from "@fortawesome/free-brands-svg-icons";

const socialsData = [
  {
    name: "GitLab",
    icon: faGithub,
    color: "#181717",
    href: "https://gitlab.com/vays3btro",
    order: 5,
  },
  {
    name: "Freelance",
    icon: faFreeCodeCamp,
    color: "#053159",
    href: "https://freelance.ru/zvayslu",
    order: 4,
  },
  {
    name: "Whats App",
    icon: faWhatsapp,
    color: "#25d366",
    href: "https://wa.me/79494327399",
    order: 3,
  },
  {
    name: "Telegram",
    icon: faTelegram,
    color: "#1da1f2",
    href: "https://t.me/VaysLu",
    order: 2,
  },
  {
    name: "Vkontakte",
    icon: faVk,
    color: "#0a66c2",
    href: "https://vk.com/lucosta",
    order: 1,
  },
];

export default socialsData;
